import { graphql } from '@/gql';
import type { AddCallerToPartnerMutation, AddCallerToPartnerMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const addCallerToPartner = async ({
  phoneNumber,
  partnerCode,
}: AddCallerToPartnerMutationVariables): Promise<AddCallerToPartnerMutation['addCallerToPartner']> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation AddCallerToPartner($phoneNumber: String!, $partnerCode: String!) {
        addCallerToPartner(phoneNumber: $phoneNumber, partnerCode: $partnerCode) {
          callerId
          partnerId
          credits
          rides
          partnerCode
          partnerName
          callerPhoneNumber
          callerFirstName
          callerLastName
        }
      }
    `),
    variables: {
      phoneNumber,
      partnerCode,
    },
  });

  return response.data?.addCallerToPartner;
};
